import { render, staticRenderFns } from "./Profit.vue?vue&type=template&id=03cae3ca&scoped=true&"
import script from "./Profit.vue?vue&type=script&lang=js&"
export * from "./Profit.vue?vue&type=script&lang=js&"
import style0 from "./Profit.vue?vue&type=style&index=0&id=03cae3ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cae3ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03cae3ca')) {
      api.createRecord('03cae3ca', component.options)
    } else {
      api.reload('03cae3ca', component.options)
    }
    module.hot.accept("./Profit.vue?vue&type=template&id=03cae3ca&scoped=true&", function () {
      api.rerender('03cae3ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/page_price_versions/components/Profit.vue"
export default component.exports